/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Roles.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Roles
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ROLE_LIST_CONTAINER_LOADED,
    ROLE_LIST_CONTAINER_UNLOADED,
    ROLE_LIST_TABLE_LOADED,
    ROLE_LIST_TABLE_UNLOADED,
    ROLE_SELECT_ROW,
    ROLE_ADD,
    ROLE_EDIT,
    ROLE_DELETE,
    ROLE_OPEN_WARNING,
    ROLE_CLOSE_WARNING,
    ROLE_EDIT_CONTAINER_LOADED,
    ROLE_EDIT_CONTAINER_UNLOADED,
    ROLE_EDIT_FORM_LOADED,
    ROLE_EDIT_FORM_UNLOADED,
    ROLE_EDIT_DATA_LOAD,
    ROLE_SET_TREE,
    ROLE_LOAD_PERMISSIONS,
    ROLE_EDIT_UPDATE_CHECKED,
    ROLE_EDIT_UPDATE_EXPANDED,
    ROLE_EDIT_CONTAINER_SUBMIT,
    ROLE_EDIT_RESET_TREE,
    ROLE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeRoles';

const defaultState = {
    refreshList: false,
    roles: [],
    danger: false,
    roleid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ROLE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                roles: action.payload ? action.payload.roles : []
            }
        case ROLE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case ROLE_SELECT_ROW:
            return {
                ...state,
                roleid: action.id
            }
        case ROLE_ADD:
            return {
                ...state
            }
        case ROLE_EDIT:
            return {
                ...state,
                roleid: action.id
            }
        case ROLE_DELETE:
            return {
                ...state,
                roleid: null
            }
        case ROLE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case ROLE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case ROLE_EDIT_CONTAINER_LOADED:
        case ROLE_EDIT_DATA_LOAD:
            return {
                ...state,
                roleid: action.payload ? action.payload.roleid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case ROLE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case ROLE_SET_TREE:
            return {
                ...state,
                roletree: action.payload && action.payload[1] ? action.payload[1] : {},
                roletreeinit: action.payload && action.payload[2] ? action.payload[2].records : [],
                roletreechecked: action.payload && action.payload[2] ? action.payload[2].records : [],
                roleexpandinit: [],
                roletreeexpanded: []
            }
        case ROLE_LOAD_PERMISSIONS:
            return {
                ...state,
                roletreeinit: action.payload ? action.payload : [],
                roletreechecked: action.payload ? action.payload : []
            }
        case ROLE_EDIT_RESET_TREE:
            return {
                ...state,
                roletreechecked: state.roletreeinit ? state.roletreeinit : [],
                roletreeexpanded: state.roleexpandinit ? state.roleexpandinit : []
            }
        case ROLE_EDIT_UPDATE_CHECKED:
            return {
                ...state,
                roletreechecked: action.payload ? action.payload : []
            }
        case ROLE_EDIT_UPDATE_EXPANDED:
            return {
                ...state,
                roletreeexpanded: action.payload ? action.payload : []
            }
        case ROLE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case ROLE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case ROLE_LIST_CONTAINER_UNLOADED:
        case ROLE_LIST_TABLE_UNLOADED:
        case ROLE_EDIT_CONTAINER_UNLOADED:
        case ROLE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Roles.js